import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'rent',
    loadChildren: () => import('./features/rent/rent.routes').then((m) => m.RENT_ROUTES),
  },
  {
    path: 'restoring-access',
    loadChildren: () =>
      import('./features/restoring-access/restoring-access.routes').then(
        (m) => m.RESTORING_ACCESS_ROUTES,
      ),
  },
  {
    path: 'change-phone-number',
    loadChildren: () =>
      import('./features/change-phone-number/change-phone-number.routes').then(
        (m) => m.CHANGE_PHONE_NUMBER_ROUTES,
      ),
  },
  {
    path: 'additional-phone-number',
    loadChildren: () =>
      import('./features/additional-phone-number/additional-phone-number.routes').then(
        (m) => m.ADDITIONAL_PHONE_NUMBER_ROUTES,
      ),
  },
  {
    path: 'upgrade-additional-to-main',
    loadChildren: () =>
      import('./features/upgrade-additional-to-main/upgrade-additional-to-main.routes').then(
        (m) => m.UPGRADE_ADDITIONAL_TO_MAIN_ROUTES,
      ),
  },
  {
    path: 'invalid-link',
    loadComponent: () =>
      import('./shared/components/invalid-link/invalid-link.component').then(
        (m) => m.InvalidLinkComponent,
      ),
  },
  {
    path: '**',
    redirectTo: 'invalid-link',
  },
];
